import type { CompType } from '@aloft/toolkit-shared';
import { isString } from '@aloft/toolkit-shared';
import { Block, Button, Flex, Typography } from '@aloft/toolkit-sui';

import { CompTypeBadge } from '../../components/CompTypeBadge.tsx';
import {
  ALERT_TOAST_DATA_ATTR,
  ALERT_TOAST_PROPERTY_ID_ATTR,
  ALERT_TOAST_TARGET_CELL_KEY_ATTR,
} from './constants.ts';
import type { ToastOptions } from './types.ts';

export const RenderToast = ({
  title,
  body,
  compType,
  onClick,
  isClickable,
  action,
  alertType,
  alertPropertyID,
  alertTargetCellKey,
  alertSeverity,
}: {
  title: ToastOptions['title'];
  body: ToastOptions['body'];
  compType?: CompType;
  onClick?: () => void;
  isClickable?: boolean;
  action?: {
    text: string;
    onClick: () => void;
  };
  alertType?: ToastOptions['alertType'];
  alertPropertyID?: ToastOptions['alertPropertyID'];
  alertTargetCellKey?: ToastOptions['alertTargetCellKey'];
  alertSeverity?: ToastOptions['type'];
}) => {
  let paragraphs: string[] = [];
  if (Array.isArray(body)) {
    paragraphs = body;
  } else if (isString(body)) {
    paragraphs = [body];
  }

  return (
    <Flex
      alignItems="center"
      onClick={onClick}
      __dangerDoNotUseSx={isClickable ? { cursor: 'pointer', minWidth: 0 } : { minWidth: 0 }}
      {...(alertType ? { [ALERT_TOAST_DATA_ATTR]: alertType } : {})}
      {...(alertPropertyID ? { [ALERT_TOAST_PROPERTY_ID_ATTR]: alertPropertyID } : {})}
      {...(alertTargetCellKey ? { [ALERT_TOAST_TARGET_CELL_KEY_ATTR]: alertTargetCellKey } : {})}
      {...(alertSeverity ? { 'data-alert-severity': alertSeverity } : {})}
    >
      <Block
        flex={1}
        __dangerDoNotUseSx={{
          minWidth: 0,
        }}
      >
        <Typography variant="h4" __dangerDoNotUseSx={{ marginBottom: 1 }}>
          {title}
        </Typography>
        <Flex alignItems="flex-end">
          {paragraphs.map((x) => (
            <Typography key={x}>{x}</Typography>
          ))}
          {action && <Button text={action.text} onClick={action.onClick} marginLeft="1.5rem" />}
        </Flex>
      </Block>
      {compType && (
        <Flex alignItems="center" alignSelf="stretch" marginLeft="auto">
          <CompTypeBadge compType={compType} />
        </Flex>
      )}
    </Flex>
  );
};
